export default __webpack_public_path__ + "static/media/spaceship_uzi.81c791cc.png";